module.exports = __webpack_public_path__ + "img/dazzle-i.705d7e42.png";